import React, { useState } from 'react'
import {
    Collapse,
    Button,
} from 'reactstrap'
import { IoIosAddCircleOutline } from "react-icons/io"

import RichText from './rich-text'

export default ({ content }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)
  const triggerText = content.triggerRichText ? <RichText content={content.triggerRichText}/> : content.triggerText

  return (
    <div>
      <Button onClick={ toggle }>{ triggerText }<span className="add-circle"><IoIosAddCircleOutline/></span></Button>
      <Collapse isOpen={ isOpen }>
        <RichText content={ content.body }/>
      </Collapse>
    </div>
  )
}
